var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"value":_vm.value,"size":_vm.size,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"filterable":"","clearable":"","multiple":"","collapse-tags":true},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }